import React from 'react';

function Blog() {
  return <section className="tc-blog-style4"></section>;
}

export default Blog;
